export const ApiBaseUrl = "https://test-app.khalidelewa.com";
export const ApiBaseUrl2 = "https://localhost:5001";
